import { DEFAULT_LOCALIZATION, normalizeLocalization } from '../lib/localization';

let activeLocalization = DEFAULT_LOCALIZATION;

export function setFormatterLocalization(settings) {
  activeLocalization = normalizeLocalization(settings);
}

export function getFormatterLocalization() {
  return activeLocalization;
}

export const currency = (value, overrides = {}) => {
  const settings = { ...activeLocalization, ...overrides };
  return new Intl.NumberFormat(settings.locale, {
    style: 'currency',
    currency: settings.currency,
  }).format(Number(value || 0));
};

export const number = (value, options = {}) =>
  new Intl.NumberFormat(activeLocalization.locale, options).format(Number(value || 0));

export const date = (value, options = {}) => {
  if (!value) return '-';
  const normalizedValue = typeof value === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(value)
    ? `${value}T12:00:00`
    : value;
  const parsed = normalizedValue instanceof Date ? normalizedValue : new Date(normalizedValue);
  if (Number.isNaN(parsed.getTime())) return '-';
  return new Intl.DateTimeFormat(activeLocalization.locale, {
    timeZone: activeLocalization.timeZone,
    ...options,
  }).format(parsed);
};

export const dateBR = (value) => date(value);
export const dateFull = (value) => date(value, { weekday: 'long', day: '2-digit', month: 'long' });
export const dateTime = (value) => date(value, { dateStyle: 'short', timeStyle: 'short' });
export const distanceUnit = () => activeLocalization.measurementSystem === 'imperial' ? 'mi' : 'km';
export const distance = (value) => `${number(value, { maximumFractionDigits: 0 })} ${distanceUnit()}`;
export const plate = (value = '') => String(value).toUpperCase().replace(/[^A-Z0-9 -]/g, '').slice(0, 15);

